import type { Consent } from '@repo/domain';
import { type TestId } from '@repo/test-id';
import { Checkbox } from '@repo/ui';

import ConsentLabel from '@shared/components/consent/ConsentLabel';

interface Props {
  consent: Consent;
  checked: boolean;
  onChange: (value: boolean) => void;
  testId: TestId;
}

export default function ConsentToggle({ consent, checked, onChange, testId }: Props) {
  return (
    <Checkbox
      testId={testId}
      checked={checked}
      onChange={onChange}
      label={
        <>
          {consent.isRequired && <span className="text-fg-danger">*</span>}
          <ConsentLabel type={consent.type} />
        </>
      }
    />
  );
}
